import classes from './Card.module.css';

function Card(props) {
	return (
		<div className={classes[props.type]}>
			<div className={classes.title}>{props.title}</div>
			<div className={classes.text}>{props.text}</div>
		</div>
	)

}

export default Card;